import { render, staticRenderFns } from "./StatisticsListTable.vue?vue&type=template&id=1d6f320d"
import script from "./StatisticsListTable.vue?vue&type=script&lang=js"
export * from "./StatisticsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports